export default __webpack_public_path__ + "static/media/react-redux.fb61d456.jpg";